import React, { useEffect, useState } from "react";
import useBreadcrumbs from "../../../hooks/useBreadCrumbs";
import { Button, Col, Container, Row } from "react-bootstrap";
import NavCrumbs from "../../../common/NavCrumbs";
import DataTable from "../../../common/DataTable";
import { MASTER_NOTIFICATION_PREFERENCE_HEADERS } from "./actions/constant";
import {
  fetchNotificationCongiguration,
  updateNotificationConfiguration,
} from "../../../services/NotificationConfigurationAPI";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import Snackbar from "../../../common/Snackbar";

const NotificationConfigurationMaster = () => {
  const userID = useSelector((state: RootState) => state.auth.userid);
  const breadcrumbs = useBreadcrumbs();
  const [configurationData, setConfigurationData] = useState<any[]>([]);
  const [configurationResultData, setConfigurationResultData] = useState<any[]>(
    []
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");

  const fetchNotificationCongigurationData = async () => {
    setLoading(true);
    try {
      const configuration = await fetchNotificationCongiguration();
      if (configuration) {
        setConfigurationData(configuration);
        setConfigurationResultData(configuration);
      } else {
        console.error("No data found in Notification Configuration result");
      }
    } catch (error) {
      console.error("Error fetching configuration:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotificationCongigurationData();
  }, [userID]);

  const handleCheckboxChange = (rowId: any, key: string) => {
    setConfigurationData((prevData) =>
      prevData.map((item) =>
        item.id === rowId ? { ...item, [key]: item[key] === 1 ? 0 : 1 } : item
      )
    );
  };

  const handleSave = async () => {
    try {
      // 🔍 find only changed rows
      const changedConfigurations = configurationData.filter((item) => {
        const original = configurationResultData.find((o) => o.id === item.id);

        if (!original) return false; // safety check

        return (
          original.isEmailNotification !== item.isEmailNotification ||
          original.isSmsNotification !== item.isSmsNotification ||
          original.isInAppNotification !== item.isInAppNotification
        );
      });

      const updatePayload = {
        configurations: changedConfigurations.map((item) => ({
          notificationConfigurationId: item.id,
          roleId: item.roleId,
          isEmailNotification: item.isEmailNotification,
          isSmsNotification: item.isSmsNotification,
          isInAppNotification: item.isInAppNotification,
        })),
        triggerById: userID,
      };

      const response = await updateNotificationConfiguration(updatePayload);
      const successMessage =
        "Configuration Notifications updated successfully.";
      if (response.isSuccess) {
        setSnackbarMessage(successMessage);
        setError("success");
        setSnackbarOpen(true);

        // ✅ update original data so next comparison works correctly
        setConfigurationResultData(configurationData);
      }
    } catch (error) {
      console.error("Error while saving notification configuration:", error);
      setSnackbarMessage("An unexpected error occurred.");
      setError("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div>
        <Snackbar
          open={snackbarOpen}
          message={snackbarMessage}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />
        <div className="breadcrumbg">
          <Container fluid className="px-5">
            <div className="pt-0 flex-column d-flex align-items-start fade-in-left">
              <h4>NOTIFICATION PREFERENCES</h4>
              <NavCrumbs breadcrumbs={breadcrumbs} />
            </div>
          </Container>
        </div>
        <>
          <div className="main_wrapper_section">
            <div className="container-fluid px-5">
              <div className="d-flex   py-2 search_closer align-items-center">
                <div className="sectionTitle noborder me-auto">List</div>
              </div>
              <div className="borderB mb-3"> </div>
              <div className="adjustHeightTb">
              <DataTable
                headers={MASTER_NOTIFICATION_PREFERENCE_HEADERS}
                rows={configurationData}
                onDownloadAction={handleCheckboxChange}
              />
              </div>
              {/* Display entries text on the left */}

              <div className="row">
                <Row className="my-3 mx-0">
                  <Col className="d-flex justify-content-end align-items-end">
                    <Button
                      variant="outline-info"
                      className="d-flex align-items-center"
                      onClick={fetchNotificationCongigurationData}
                    >
                      <span className="material-icons mr-2">close</span>
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className="ms-3 d-flex align-items-center"
                      onClick={handleSave}
                    >
                      <span className="material-icons mx-1">save</span>
                      Save
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </>
      </div>
    </>
  );
};

export default NotificationConfigurationMaster;
